import { createContext } from 'react';

var InstantSearchSSRContext = createContext(null);

export { InstantSearchSSRContext };
